import { get, ref, remove, serverTimestamp, set, update } from "firebase/database";
import { database, requestNotificationPermission } from "../constants/firebase";
import { v4 as uuidv4 } from "uuid";
import imageCompression from "browser-image-compression";
import heic2any from "heic2any";

const ratings = [
    {
        name: "Terrible",
        emoji: (
            <svg
                className="w-12 h-12 md:w-16 md:h-16"
                viewBox="0 0 111 111"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M55.1249 110.25C85.5696 110.25 110.25 85.5696 110.25 55.1249C110.25 24.6803 85.5696 0 55.1249 0C24.6803 0 0 24.6803 0 55.1249C0 85.5696 24.6803 110.25 55.1249 110.25Z"
                    fill="#FFD060"
                />
                <path
                    d="M110.258 55.1245C110.258 85.5699 85.5693 110.249 55.1335 110.249C35.4931 110.249 18.2528 99.9702 8.48047 84.5085C16.9428 89.672 26.8873 92.6362 37.5203 92.6362C68.396 92.6362 93.4101 67.6124 93.4101 36.7463C93.4101 26.9644 90.8953 17.7848 86.4873 9.79102C100.849 19.7355 110.258 36.3351 110.258 55.1245Z"
                    fill="#FDC357"
                />
                <path
                    d="M92.6054 21.1104C83.7223 13.6903 72.3053 9.21524 59.8364 9.18655C32.4031 9.11962 8.88056 32.1832 8.43114 59.6165C8.24946 70.6989 11.577 80.9972 17.3907 89.4691C17.4864 89.6125 17.2856 89.7655 17.1708 89.6412C8.48852 80.0888 3.35372 67.247 3.86051 53.2196C4.85496 25.9679 27.4308 4.05176 54.6921 3.83183C69.9052 3.70753 83.598 10.2001 93.074 20.6036C93.3704 20.9287 92.9401 21.3877 92.6054 21.1104Z"
                    fill="#FFDA8C"
                />
                <path
                    d="M45.8881 53.6926C45.802 53.6926 45.7064 53.6926 45.6203 53.6831C40.9732 53.2145 36.3835 52.1627 32.0041 50.5563C28.0932 49.122 24.3449 47.2479 20.8452 44.9721C19.6117 44.1689 19.2675 42.5242 20.0611 41.3003C20.8643 40.0668 22.509 39.7226 23.7329 40.5162C26.898 42.572 30.2925 44.2645 33.8304 45.5649C37.7986 47.0184 41.939 47.965 46.1463 48.3953C47.6092 48.5387 48.6706 49.8487 48.5272 51.3021C48.3838 52.6695 47.2363 53.6926 45.8881 53.6926Z"
                    fill="black"
                />
                <path
                    d="M64.3728 53.693C63.0246 53.693 61.8676 52.6698 61.7337 51.3025C61.5903 49.8395 62.6516 48.539 64.1146 48.3956C68.3219 47.9749 72.4718 47.0187 76.4305 45.5653C79.9684 44.2648 83.3629 42.5724 86.528 40.5165C87.7614 39.7133 89.4061 40.0671 90.1998 41.3006C91.003 42.5341 90.6492 44.1788 89.4157 44.9724C85.916 47.2386 82.1677 49.1223 78.2568 50.5566C73.8774 52.163 69.2972 53.2149 64.6405 53.6834C64.5545 53.6834 64.4589 53.693 64.3728 53.693Z"
                    fill="black"
                />
                <path
                    d="M39.3237 62.2861C42.7517 61.4767 44.8745 58.0415 44.065 54.6136C43.2556 51.1856 39.8205 49.0628 36.3925 49.8723C32.9645 50.6817 30.8417 54.1168 31.6512 57.5448C32.4606 60.9728 35.8957 63.0956 39.3237 62.2861Z"
                    fill="black"
                />
                <path
                    d="M76.9063 60.5938C79.397 58.1031 79.397 54.0649 76.9063 51.5742C74.4156 49.0835 70.3774 49.0835 67.8867 51.5742C65.396 54.0649 65.3961 58.1031 67.8867 60.5938C70.3774 63.0844 74.4156 63.0845 76.9063 60.5938Z"
                    fill="black"
                />
                <path
                    d="M43.86 83.614C43.2385 83.614 42.6074 83.3941 42.1006 82.9542C41.001 81.9884 40.8958 80.3055 41.8615 79.2059C43.1237 77.7716 47.8378 73.0958 55.3726 73.201C62.6302 73.3061 67.1626 77.8194 68.377 79.2059C69.3427 80.3055 69.2375 81.9884 68.1379 82.9542C67.0383 83.92 65.3554 83.8148 64.3896 82.7152C63.7872 82.0267 60.4979 78.5844 55.2961 78.5174C49.8936 78.4409 46.48 82.0076 45.8489 82.7152C45.3325 83.308 44.5963 83.614 43.86 83.614Z"
                    fill="black"
                />
            </svg>
        ),
    },
    {
        name: "Bad",
        emoji: (
            <svg
                className="w-12 h-12 md:w-16 md:h-16"
                viewBox="0 0 112 111"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M56.0683 110.25C86.5129 110.25 111.193 85.5696 111.193 55.1249C111.193 24.6803 86.5129 0 56.0683 0C25.6236 0 0.943359 24.6803 0.943359 55.1249C0.943359 85.5696 25.6236 110.25 56.0683 110.25Z"
                    fill="#FFD060"
                />
                <path
                    d="M111.192 55.1245C111.192 85.5699 86.5029 110.249 56.067 110.249C36.4267 110.249 19.1864 99.9702 9.41406 84.5085C17.8764 89.672 27.8209 92.6362 38.4538 92.6362C69.3295 92.6362 94.3437 67.6124 94.3437 36.7463C94.3437 26.9644 91.8289 17.7848 87.4209 9.79102C101.793 19.7355 111.192 36.3351 111.192 55.1245Z"
                    fill="#FDC357"
                />
                <path
                    d="M93.541 21.1104C84.6674 13.6903 73.2408 9.21524 60.7816 9.18655C33.3482 9.11962 9.82567 32.1832 9.36669 59.6165C9.18502 70.6989 12.5126 80.9972 18.3263 89.4691C18.4219 89.6125 18.2211 89.7655 18.1064 89.6412C9.42407 80.0983 4.28927 67.2566 4.79605 53.2196C5.7905 25.9774 28.3664 4.05176 55.6276 3.83183C70.8408 3.70753 84.5336 10.2001 94.0095 20.6036C94.3059 20.9287 93.8756 21.3877 93.541 21.1104Z"
                    fill="#FFDA8C"
                />
                <path
                    d="M17.4375 37.166C17.4375 46.2021 24.762 53.5362 33.8076 53.5362C42.8437 53.5362 50.1778 46.2117 50.1778 37.166H17.4375Z"
                    fill="white"
                />
                <path
                    d="M35.9211 39.5009C35.9211 43.0771 33.0143 45.9839 29.4381 45.9839C25.8619 45.9839 22.9551 43.0771 22.9551 39.5009C22.9551 38.6786 23.1081 37.8849 23.3854 37.1582H35.4813C35.7682 37.8945 35.9211 38.6786 35.9211 39.5009Z"
                    fill="black"
                />
                <path
                    d="M61.9668 37.166C61.9668 46.2021 69.2913 53.5362 78.3369 53.5362C87.3826 53.5362 94.7071 46.2117 94.7071 37.166H61.9668Z"
                    fill="white"
                />
                <path
                    d="M80.4504 39.5009C80.4504 43.0771 77.5436 45.9839 73.9674 45.9839C70.3912 45.9839 67.4844 43.0771 67.4844 39.5009C67.4844 38.6786 67.6374 37.8849 67.9147 37.1582H80.0106C80.2975 37.8945 80.4504 38.6786 80.4504 39.5009Z"
                    fill="black"
                />
                <path
                    d="M85.5284 73.074C85.4424 72.9784 83.2813 70.6931 80.3362 68.6468C75.9664 65.6061 72.0938 64.6116 68.8427 65.673C65.1231 66.8874 61.7764 69.7082 59.0991 71.9744C58.5158 72.4621 57.8369 73.0453 57.2249 73.5234C56.546 74.0589 55.5898 74.0589 54.9204 73.5234C54.3085 73.0358 53.62 72.4621 53.0463 71.9744C50.3594 69.7082 47.0222 66.897 43.3026 65.673C40.042 64.6021 36.1789 65.6061 31.8091 68.6468C28.864 70.6931 26.7126 72.9784 26.6169 73.074C25.6129 74.145 25.6703 75.8183 26.7317 76.8223C27.8026 77.8263 29.476 77.7785 30.4895 76.7076C32.7557 74.3075 38.4642 69.6795 41.6484 70.7218C44.3927 71.6206 47.29 74.0685 49.6231 76.0287C52.2048 78.2088 54.0694 79.777 56.0774 79.777C58.0855 79.777 59.9596 78.2088 62.5318 76.0287C64.8649 74.0589 67.7622 71.611 70.5065 70.7218C73.6906 69.6795 79.3992 74.3075 81.6654 76.7076C82.6694 77.7785 84.3523 77.8263 85.4232 76.8223C86.475 75.8183 86.5324 74.145 85.5284 73.074Z"
                    fill="black"
                />
            </svg>
        ),
    },
    {
        name: "Ok",
        emoji: (
            <svg
                className="w-12 h-12 md:w-16 md:h-16"
                viewBox="0 0 112 111"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M55.998 110.25C86.4426 110.25 111.123 85.5696 111.123 55.1249C111.123 24.6803 86.4426 0 55.998 0C25.5533 0 0.873047 24.6803 0.873047 55.1249C0.873047 85.5696 25.5533 110.25 55.998 110.25Z"
                    fill="#FFD060"
                />
                <path
                    d="M111.124 55.1245C111.124 85.5699 86.4345 110.249 55.9987 110.249C36.3583 110.249 19.1181 99.9702 9.3457 84.5085C17.8081 89.672 27.7525 92.6362 38.3855 92.6362C69.2612 92.6362 94.2754 67.6124 94.2754 36.7463C94.2754 26.9644 91.7606 17.7848 87.3525 9.79102C101.724 19.7355 111.124 36.3351 111.124 55.1245Z"
                    fill="#FDC357"
                />
                <path
                    d="M93.4726 21.1104C84.5991 13.6903 73.1725 9.21524 60.7132 9.18655C33.2798 9.11962 9.75731 32.1832 9.29834 59.6165C9.11666 70.6989 12.4442 80.9972 18.2579 89.4691C18.3535 89.6125 18.1527 89.7655 18.038 89.6412C9.3557 80.0983 4.22091 67.2566 4.7277 53.2196C5.72214 25.9774 28.298 4.05176 55.5593 3.83183C70.7724 3.70753 84.4652 10.2001 93.9411 20.6036C94.2376 20.9287 93.8073 21.3877 93.4726 21.1104Z"
                    fill="#FFDA8C"
                />
                <path
                    d="M82.0108 57.2367C84.8749 54.3726 84.8749 49.729 82.0108 46.8649C79.1467 44.0008 74.5031 44.0008 71.639 46.8649C68.7749 49.729 68.7749 54.3726 71.639 57.2367C74.5031 60.1008 79.1467 60.1008 82.0108 57.2367Z"
                    fill="black"
                />
                <path
                    d="M40.3546 57.2269C43.2187 54.3628 43.2187 49.7192 40.3546 46.8551C37.4905 43.991 32.8469 43.991 29.9828 46.8551C27.1187 49.7192 27.1187 54.3628 29.9828 57.2269C32.8469 60.091 37.4905 60.091 40.3546 57.2269Z"
                    fill="black"
                />
                <path
                    d="M64.782 76.5411H47.2071C45.7441 76.5411 44.5488 75.3554 44.5488 73.8828C44.5488 72.4199 45.7345 71.2246 47.2071 71.2246H64.782C66.245 71.2246 67.4402 72.4103 67.4402 73.8828C67.4402 75.3458 66.245 76.5411 64.782 76.5411Z"
                    fill="black"
                />
            </svg>
        ),
    },
    {
        name: "Good",
        emoji: (
            <svg
                className="w-12 h-12 md:w-16 md:h-16"
                viewBox="0 0 112 111"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M55.9335 110.25C86.3782 110.25 111.058 85.5696 111.058 55.1249C111.058 24.6803 86.3782 0 55.9335 0C25.4889 0 0.808594 24.6803 0.808594 55.1249C0.808594 85.5696 25.4889 110.25 55.9335 110.25Z"
                    fill="#FFD060"
                />
                <path
                    d="M111.067 55.1245C111.067 85.5699 86.3779 110.249 55.942 110.249C36.3017 110.249 19.0614 99.9702 9.28906 84.5085C17.7514 89.672 27.6959 92.6362 38.3288 92.6362C69.2045 92.6362 94.2187 67.6124 94.2187 36.7463C94.2187 26.9644 91.7039 17.7848 87.2958 9.79102C101.658 19.7355 111.067 36.3351 111.067 55.1245Z"
                    fill="#FDC357"
                />
                <path
                    d="M93.4062 21.1104C84.5327 13.6903 73.1061 9.21524 60.6468 9.18655C33.2134 9.11962 9.69093 32.1832 9.23195 59.6165C9.05027 70.6989 12.3778 80.9972 18.1915 89.4691C18.2871 89.6125 18.0864 89.7655 17.9716 89.6412C9.28931 80.0983 4.1545 67.2566 4.66129 53.2196C5.65574 25.9774 28.2316 4.05176 55.4929 3.83183C70.706 3.70753 84.3988 10.2001 93.8747 20.6036C94.1807 20.9287 93.7409 21.3877 93.4062 21.1104Z"
                    fill="#FFDA8C"
                />
                <path
                    d="M45.4224 51.7197C44.7435 51.7197 44.0646 51.4615 43.5482 50.9452L35.956 43.353L28.3638 50.9452C27.3215 51.9874 25.6482 51.9874 24.6059 50.9452C23.5637 49.9029 23.5637 48.2296 24.6059 47.1873L34.0819 37.7114C35.1241 36.6691 36.7975 36.6691 37.8397 37.7114L47.3157 47.1873C48.3579 48.2296 48.3579 49.9029 47.3157 50.9452C46.7897 51.4615 46.1013 51.7197 45.4224 51.7197Z"
                    fill="black"
                />
                <path
                    d="M85.3833 51.7197C84.7044 51.7197 84.0255 51.4615 83.5092 50.9452L75.917 43.353L68.3247 50.9452C67.2825 51.9874 65.6091 51.9874 64.5668 50.9452C63.5246 49.9029 63.5246 48.2296 64.5668 47.1873L74.0428 37.7114C75.0851 36.6691 76.7584 36.6691 77.8007 37.7114L87.2766 47.1873C88.3189 48.2296 88.3189 49.9029 87.2766 50.9452C86.7507 51.4615 86.0622 51.7197 85.3833 51.7197Z"
                    fill="black"
                />
                <path
                    d="M55.9394 78.5104C55.7482 78.5104 55.5473 78.5104 55.3561 78.5104C47.3527 78.3765 41.1852 75.5653 37.4178 73.2226C36.1747 72.4481 35.7923 70.813 36.5668 69.5604C37.3413 68.3173 38.9764 67.9348 40.229 68.7094C43.4227 70.6982 48.6627 73.0888 55.4517 73.1939C63.0535 73.3182 68.8672 70.4305 71.6497 68.7094C72.8928 67.9348 74.5375 68.3173 75.312 69.5604C76.0865 70.8034 75.704 72.4481 74.461 73.2226C70.531 75.6418 64.1723 78.5104 55.9394 78.5104Z"
                    fill="black"
                />
            </svg>
        ),
    },
    {
        name: "Excellent",
        emoji: (
            <svg
                className="w-12 h-12 md:w-16 md:h-16"
                viewBox="0 0 111 111"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M55.8749 110.25C86.3196 110.25 111 85.5696 111 55.1249C111 24.6803 86.3196 0 55.8749 0C25.4303 0 0.75 24.6803 0.75 55.1249C0.75 85.5696 25.4303 110.25 55.8749 110.25Z"
                    fill="#FFD060"
                />
                <path
                    d="M111.001 55.1245C111.001 85.5699 86.3115 110.249 55.8756 110.249C36.2353 110.249 18.995 99.9702 9.22266 84.5085C17.685 89.672 27.6295 92.6362 38.2625 92.6362C69.1382 92.6362 94.1523 67.6124 94.1523 36.7463C94.1523 26.9644 91.6375 17.7848 87.2294 9.79102C101.601 19.7355 111.001 36.3351 111.001 55.1245Z"
                    fill="#FDC357"
                />
                <path
                    d="M93.3495 21.1104C84.476 13.6903 73.0494 9.21524 60.5902 9.18655C33.1568 9.11962 9.63424 32.1832 9.17527 59.6165C8.99359 70.6989 12.3212 80.9972 18.1349 89.4691C18.2305 89.6125 18.0297 89.7655 17.9149 89.6412C9.23263 80.0983 4.09786 67.2566 4.60465 53.2196C5.5991 25.9774 28.1749 4.05176 55.4362 3.83183C70.6493 3.70753 84.3422 10.2001 93.8181 20.6036C94.1145 20.9287 93.6842 21.3877 93.3495 21.1104Z"
                    fill="#FFDA8C"
                />
                <path
                    d="M24.101 47.0443C23.2118 47.0443 22.3416 46.5949 21.8348 45.7822C21.0699 44.5295 21.4524 42.8944 22.705 42.1295L35.891 34.0113L27.3712 31.0662C25.9847 30.5881 25.2485 29.0773 25.7266 27.6909C26.2047 26.3044 27.7155 25.5681 29.1019 26.0462L42.919 30.8272C43.8848 31.1619 44.5828 32.032 44.688 33.0456C44.8027 34.0687 44.3151 35.0632 43.4354 35.5986L25.478 46.6523C25.0572 46.92 24.5696 47.0443 24.101 47.0443Z"
                    fill="black"
                />
                <path
                    d="M87.6498 47.0443C87.1717 47.0443 86.6936 46.92 86.2633 46.6523L68.3058 35.5986C67.4357 35.0632 66.948 34.0687 67.0532 33.0456C67.168 32.0224 67.8564 31.1619 68.8222 30.8272L82.6393 26.0462C84.0258 25.5681 85.5366 26.3044 86.0147 27.6909C86.4928 29.0773 85.7565 30.5881 84.37 31.0662L75.8502 34.0113L89.0363 42.1295C90.2889 42.8944 90.6713 44.5391 89.9064 45.7822C89.4092 46.5949 88.5391 47.0443 87.6498 47.0443Z"
                    fill="black"
                />
                <path
                    d="M92.0278 63.5804C90.0197 71.6508 85.4778 78.6884 79.3199 83.7658C72.9133 89.0536 64.7569 92.2186 55.8738 92.2186C46.9907 92.2186 38.8344 89.0536 32.4278 83.7658C26.2699 78.6884 21.7279 71.6508 19.7199 63.5804C18.802 59.9086 21.6132 56.3516 25.3998 56.3516H86.3479C90.1345 56.3516 92.9362 59.8991 92.0278 63.5804Z"
                    fill="black"
                />
                <path
                    d="M79.31 83.762C72.9035 89.0497 64.7471 92.2148 55.864 92.2148C46.9809 92.2148 38.8245 89.0497 32.418 83.762C37.046 75.6056 45.8143 70.1074 55.864 70.1074C65.9136 70.1074 74.682 75.6056 79.31 83.762Z"
                    fill="#ED1C24"
                />
            </svg>
        ),
    },
];

const linkifyTextCommunity = (
    text,
    mentions = [],
    isFromHost,
    onMentionClick
) => {

    if (!text) return text;

    // STEP 0: Replace structured @[Name](uid) tags with plain @Name so the
    //         rest of the pipeline can render them, then fall through to the
    //         mention-highlight step which matches by name from the mentions array.
    const normalizedText = text.replace(/@\[([^\]]+)\]\([^)]+\)/g, '@$1');

    // STEP 1: Convert mentions first
    let elements = [normalizedText];

    mentions.forEach((mention, mentionIndex) => {

        const name = mention.name;

        elements = elements.flatMap((element, index) => {

            if (typeof element !== "string") return element;

            const parts = element.split(`@${name}`);

            const result = [];

            parts.forEach((part, i) => {

                result.push(part);

                if (i < parts.length - 1) {

                    result.push(
                        <span
                            key={`mention-${mentionIndex}-${index}-${i}`}
                            className={`font-bold cursor-pointer ${isFromHost
                                ? "text-white"
                                : "text-primary"
                                }`}
                            onClick={() =>
                                onMentionClick?.(
                                    mention.name,
                                    mention.uid
                                )
                            }
                        >
                            @{name}
                        </span>
                    );

                }

            });

            return result;

        });

    });


    // STEP 2: Convert links
    const urlRegex =
        /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;

    elements = elements.flatMap((element, index) => {

        if (typeof element !== "string") return element;

        const parts = element.split(urlRegex);

        return parts.map((part, i) => {

            if (urlRegex.test(part)) {

                const href = part.startsWith("http")
                    ? part
                    : `https://${part}`;

                return (
                    <a
                        key={`link-${index}-${i}`}
                        href={href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`underline break-all ${isFromHost
                            ? "text-white"
                            : "text-primary"
                            }`}
                    >
                        {part}
                    </a>
                );

            }

            return part;

        });

    });

    return elements;

};

const linkifyText = (text, isHost, color) => {
    if (!text) return "";
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const currentOrigin = window.location.origin;

    return text.split(urlRegex).map((part, index) => {
        if (urlRegex.test(part)) {
            const isSameOrigin = part.startsWith(currentOrigin);
            return (
                <a
                    key={index}
                    href={part}
                    {...(!isSameOrigin
                        ? { target: "_blank", rel: "noopener noreferrer" }
                        : {})}
                    className={`${isHost ? "text-white" : color || "text-black"} underline`}
                >
                    {part}
                </a>
            );
        }
        return part;
    });
};

// Format time for messages
const formatTime = (timestamp) => {
    if (!timestamp) return "00:00";
    const date = new Date(timestamp);
    return date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    });
};

// Format date for today/yesterday/etc.
const formatDate = (timestamp) => {
    const today = new Date();
    const messageDate = new Date(timestamp);

    if (messageDate.toDateString() === today.toDateString()) {
        return "Today";
    }

    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    if (messageDate.toDateString() === yesterday.toDateString()) {
        return "Yesterday";
    }

    return messageDate.toLocaleDateString();
};

const getChatId = (uid1, uid2) => {
    return uid1 < uid2 ? `${uid1}_${uid2}` : `${uid2}_${uid1}`;
};

// const EMOJIS = [
//     { id: "terrible", url: "https://firebasestorage.googleapis.com/v0/b/zylen-app.firebasestorage.app/o/emojis%2F1%20Terrible.png?alt=media&token=26f8ee8a-069e-411a-a991-8f69665f0053" },
//     { id: "bad", url: "https://firebasestorage.googleapis.com/v0/b/zylen-app.firebasestorage.app/o/emojis%2F2%20Bad.png?alt=media&token=e657a4a3-b2a8-473f-a343-59761f558ebe" },
//     { id: "okay", url: "https://firebasestorage.googleapis.com/v0/b/zylen-app.firebasestorage.app/o/emojis%2F3%20Okay.png?alt=media&token=3f6a2234-1271-47a5-8aef-ec0ed3a5157e" },
//     { id: "good", url: "https://firebasestorage.googleapis.com/v0/b/zylen-app.firebasestorage.app/o/emojis%2F4%20Good.png?alt=media&token=9b0910e0-a0b9-49df-9a86-7410dd338d6d" },
//     { id: "excellent", url: "https://firebasestorage.googleapis.com/v0/b/zylen-app.firebasestorage.app/o/emojis%2F5%20Excellent.png?alt=media&token=c00927b2-c8f6-44d0-8230-c0c3fc18e763" }
// ];

const EMOJIS = [
    { id: "heart", char: "❤️" },
    { id: "laugh", char: "😂" },
    { id: "sad", char: "🥲" },
    { id: "fire", char: "🔥" },
    { id: "pray", char: "🙏" },
];

function validateFile(file, allowedTypes, maxSizeMB = 15) {
    if (!file) return { valid: false, error: "No file selected" };

    // Check MIME type
    if (!allowedTypes.includes(file.type)) {
        return { valid: false, error: "Invalid file type" };
    }

    // Check size
    const maxSize = maxSizeMB * 1024 * 1024;
    if (file.size > maxSize) {
        return { valid: false, error: `File size exceeds ${maxSizeMB}MB` };
    }

    return { valid: true };
}

// Helper: Convert any image file to WebP Blob
const convertToWebP = (file) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(file);

        img.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            canvas.width = img.width;
            canvas.height = img.height;

            ctx.drawImage(img, 0, 0);

            canvas.toBlob(
                (blob) => {
                    if (blob) {
                        // Rename to .webp
                        const newFile = new File(
                            [blob],
                            file.name.replace(/\.[^/.]+$/, "") + ".webp",
                            {
                                type: "image/webp",
                            },
                        );
                        resolve(newFile);
                    } else {
                        reject(new Error("WebP conversion failed."));
                    }
                },
                "image/webp",
                0.9, // quality (0–1)
            );
        };

        img.onerror = (err) => reject(err);
    });
};

const LEGACY_PORTRAIT_BUNNY_VIDEO_IDS = new Set([
    "8fc9d654-76d1-4d2f-b2d8-d639e7482200",
]);

const normalizeVideoOrientation = (orientation) => {
    if (typeof orientation !== "string") return null;

    const normalized = orientation.trim().toLowerCase();
    return ["portrait", "landscape", "square"].includes(normalized)
        ? normalized
        : null;
};

const deriveOrientationFromDimensions = (width, height) => {
    const numericWidth = Number(width);
    const numericHeight = Number(height);

    if (!numericWidth || !numericHeight) return null;

    if (numericHeight > numericWidth) return "portrait";
    if (numericWidth > numericHeight) return "landscape";
    return "square";
};

const getVideoFileMetadata = (videoFile) => {
    if (!videoFile) {
        return Promise.resolve({
            width: null,
            height: null,
            orientation: null,
        });
    }

    return new Promise((resolve) => {
        const objectUrl = URL.createObjectURL(videoFile);
        const video = document.createElement("video");

        const cleanup = () => {
            video.removeAttribute("src");
            video.load();
            URL.revokeObjectURL(objectUrl);
        };

        video.preload = "metadata";
        video.muted = true;
        video.playsInline = true;

        video.onloadedmetadata = () => {
            const width = video.videoWidth || null;
            const height = video.videoHeight || null;

            cleanup();
            resolve({
                width,
                height,
                orientation: deriveOrientationFromDimensions(width, height),
            });
        };

        video.onerror = () => {
            cleanup();
            resolve({
                width: null,
                height: null,
                orientation: null,
            });
        };

        video.src = objectUrl;
    });
};

const checkBunnyVideoStatus = async (videoId) => {
    const API_KEY = "eb14ec16-2cad-49f4-bf70b2e1c519-3382-4efe";
    const LIBRARY_ID = "516391";

    const res = await fetch(
        `https://video.bunnycdn.com/library/${LIBRARY_ID}/videos/${videoId}`,
        {
            headers: {
                accept: "application/json",
                AccessKey: API_KEY,
            },
        },
    );

    if (!res.ok) throw new Error("Failed to fetch video status");

    return await res.json();
};

const uploadFileToBunny = async (
    videoFile,
    collectionName,
    videoTitle,
    onProgress,
) => {
    if (!videoFile) throw new Error("No video file provided");
    if (!collectionName) throw new Error("No collection name provided");
    if (!videoTitle) throw new Error("No video title provided");

    const API_KEY = "eb14ec16-2cad-49f4-bf70b2e1c519-3382-4efe";
    const LIBRARY_ID = "516391";

    try {
        const videoMetadata = await getVideoFileMetadata(videoFile);

        // 🧩 STEP 1: Get collections
        const collectionsRes = await fetch(
            `https://video.bunnycdn.com/library/${LIBRARY_ID}/collections`,
            {
                method: "GET",
                headers: {
                    accept: "application/json",
                    AccessKey: API_KEY,
                },
            },
        );

        if (!collectionsRes.ok)
            throw new Error("Failed to fetch collections from Bunny Stream");

        const collectionsData = await collectionsRes.json();
        const existingCollection = collectionsData.items?.find(
            (col) => col.name.toLowerCase() === collectionName.toLowerCase(),
        );

        let collectionId;

        // 🧩 STEP 2: Create collection if missing
        if (!existingCollection) {
            const createCollectionRes = await fetch(
                `https://video.bunnycdn.com/library/${LIBRARY_ID}/collections`,
                {
                    method: "POST",
                    headers: {
                        accept: "application/json",
                        "content-type": "application/json",
                        AccessKey: API_KEY,
                    },
                    body: JSON.stringify({ name: collectionName }),
                },
            );

            if (!createCollectionRes.ok)
                throw new Error("Failed to create new collection");

            const createdCol = await createCollectionRes.json();
            collectionId = createdCol.guid;
        } else {
            collectionId = existingCollection.guid;
        }

        // 🧩 STEP 3: Create new video object
        const createVideoRes = await fetch(
            `https://video.bunnycdn.com/library/${LIBRARY_ID}/videos`,
            {
                method: "POST",
                headers: {
                    accept: "application/json",
                    "content-type": "application/json",
                    AccessKey: API_KEY,
                },
                body: JSON.stringify({
                    title: videoTitle,
                    collectionId,
                }),
            },
        );

        if (!createVideoRes.ok)
            throw new Error("Failed to create video on Bunny Stream");

        const createdVideo = await createVideoRes.json();
        const videoId = createdVideo.guid;

        // -------------------------------
        // 🧩 STEP 4: Upload Video with Progress
        // -------------------------------
        const uploadUrl = `https://video.bunnycdn.com/library/${LIBRARY_ID}/videos/${videoId}`;

        await new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();

            xhr.upload.onprogress = (event) => {
                if (event.lengthComputable && onProgress) {
                    const percent = Math.round((event.loaded / event.total) * 100);
                    onProgress(percent);
                }
            };

            xhr.onload = () => {
                if (xhr.status === 200 || xhr.status === 201) resolve();
                else reject(new Error("Video upload failed"));
            };

            xhr.onerror = () => reject(new Error("Video upload network error"));

            xhr.open("PUT", uploadUrl);
            xhr.setRequestHeader("AccessKey", API_KEY);
            xhr.setRequestHeader("Content-Type", "application/octet-stream");
            xhr.send(videoFile);
        });

        // -------------------------------
        // 🧩 STEP 5: Return playback URL
        // -------------------------------
        const playbackUrl = `https://iframe.mediadelivery.net/embed/${LIBRARY_ID}/${videoId}`;

        return {
            success: true,
            videoId,
            playbackUrl,
            collectionId,
            collectionName,
            title: videoTitle,
            videoWidth: videoMetadata.width,
            videoHeight: videoMetadata.height,
            videoOrientation: videoMetadata.orientation,
        };
    } catch (error) {
        console.error("❌ Bunny upload error:", error);
        return {
            success: false,
            message: error.message,
        };
    }
};

const isBunnyVideoUrl = (url = "") => url.includes("iframe.mediadelivery.net");

const getVideoIdFromUrl = (url) => {
    try {
        const cleanUrl = String(url || "").split("?")[0].split("#")[0];
        const parts = cleanUrl.split("/").filter(Boolean);
        return parts[parts.length - 1] || null;
    } catch {
        return null;
    }
};

const resolveBunnyVideoOrientation = ({
    orientation,
    width,
    height,
    videoUrl,
} = {}) => {
    const normalizedOrientation = normalizeVideoOrientation(orientation);
    if (normalizedOrientation) return normalizedOrientation;

    const derivedOrientation = deriveOrientationFromDimensions(width, height);
    if (derivedOrientation) return derivedOrientation;

    const videoId = getVideoIdFromUrl(videoUrl);
    if (videoId && LEGACY_PORTRAIT_BUNNY_VIDEO_IDS.has(videoId)) {
        return "portrait";
    }

    return "landscape";
};

const getBunnyVideoFrameStyle = ({ orientation, variant = "modal" } = {}) => {
    const resolvedOrientation = normalizeVideoOrientation(orientation) || "landscape";

    if (variant === "inline") {
        if (resolvedOrientation === "portrait") {
            return {
                width: "min(100%, 360px)",
                aspectRatio: "9 / 16",
            };
        }

        if (resolvedOrientation === "square") {
            return {
                width: "min(100%, 420px)",
                aspectRatio: "1 / 1",
            };
        }

        return {
            width: "min(100%, 960px)",
            aspectRatio: "16 / 9",
        };
    }

    if (resolvedOrientation === "portrait") {
        return {
            width: "min(90vw, 45vh)",
            maxWidth: "420px",
            aspectRatio: "9 / 16",
        };
    }

    if (resolvedOrientation === "square") {
        return {
            width: "min(90vw, 80vh)",
            maxWidth: "700px",
            aspectRatio: "1 / 1",
        };
    }

    return {
        width: "min(90vw, 128vh)",
        maxWidth: "1100px",
        aspectRatio: "16 / 9",
    };
};

const getBunnyEmbedUrl = (
    videoUrl,
    {
        autoplay = false,
        loop = false,
        muted = false,
        preload = true,
        responsive = true,
    } = {},
) => {
    try {
        const parsedUrl = new URL(videoUrl);
        parsedUrl.searchParams.set("autoplay", String(autoplay));
        parsedUrl.searchParams.set("loop", String(loop));
        parsedUrl.searchParams.set("muted", String(muted));
        parsedUrl.searchParams.set("preload", String(preload));
        parsedUrl.searchParams.set("responsive", String(responsive));
        return parsedUrl.toString();
    } catch {
        return `${videoUrl}?autoplay=${String(autoplay)}&loop=${String(loop)}&muted=${String(muted)}&preload=${String(preload)}&responsive=${String(responsive)}`;
    }
};

const checkVideoStatus = async (videoUrl) => {
    const API_KEY = "eb14ec16-2cad-49f4-bf70b2e1c519-3382-4efe"; // from Bunny dashboard
    const LIBRARY_ID = "516391"; // e.g. 516391

    const videoId = getVideoIdFromUrl(videoUrl);
    if (!videoId) return "Error";

    try {
        const res = await fetch(
            `https://video.bunnycdn.com/library/${LIBRARY_ID}/videos/${videoId}`,
            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    AccessKey: API_KEY,
                },
            },
        );

        console.log("Response: ", res);

        if (!res.ok) throw new Error("Failed to fetch video status");

        const data = await res.json();
        return data.status; // "Waiting", "Processing", "Finished", etc.
    } catch (err) {
        console.error(err);
        return "Error";
    }
};

const deleteBunnyCollections = async (uid) => {
    const API_KEY = "eb14ec16-2cad-49f4-bf70b2e1c519-3382-4efe"; // from Bunny dashboard
    const LIBRARY_ID = "516391"; // e.g. 516391

    try {
        // 🧩 1️⃣ Get all collections
        const res = await fetch(
            `https://video.bunnycdn.com/library/${LIBRARY_ID}/collections`,
            {
                method: "GET",
                headers: {
                    accept: "application/json",
                    AccessKey: API_KEY,
                },
            },
        );

        if (!res.ok) throw new Error("Failed to fetch Bunny collections");
        const data = await res.json();

        // 🧩 2️⃣ Find the two user collections
        const targetNames = [`lessons_${uid}`, `showreels_${uid}`];
        const targetCollections = data.items.filter((col) =>
            targetNames.includes(col.name),
        );

        // 🧩 3️⃣ Delete each found collection
        for (const col of targetCollections) {
            const delRes = await fetch(
                `https://video.bunnycdn.com/library/${LIBRARY_ID}/collections/${col.guid}`,
                {
                    method: "DELETE",
                    headers: {
                        accept: "application/json",
                        AccessKey: API_KEY,
                    },
                },
            );

            if (delRes.ok) {
                console.log(`✅ Deleted Bunny collection: ${col.name}`);
            } else {
                console.warn(`⚠️ Failed to delete collection: ${col.name}`);
            }
        }

        return true;
    } catch (err) {
        console.error("❌ Error deleting Bunny collections:", err);
        return false;
    }
};

/**
 * Resize and crop an image to a square of given size (px)
 * @param {File} file - The original image file
 * @param {number} size - The desired width & height in pixels
 * @returns {Promise<Blob>} - Returns a Blob of resized image
 */
const resizeImage = (file, size = 400) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
            const img = new Image();
            img.onload = () => {
                const canvas = document.createElement("canvas");
                canvas.width = size;
                canvas.height = size;

                const ctx = canvas.getContext("2d");

                // Calculate cropping for square
                const aspect = img.width / img.height;
                let sx = 0,
                    sy = 0,
                    sWidth = img.width,
                    sHeight = img.height;

                if (aspect > 1) {
                    // width > height -> crop horizontally
                    sWidth = img.height;
                    sx = (img.width - img.height) / 2;
                } else if (aspect < 1) {
                    // height > width -> crop vertically
                    sHeight = img.width;
                    sy = (img.height - img.width) / 2;
                }

                ctx.drawImage(img, sx, sy, sWidth, sHeight, 0, 0, size, size);

                canvas.toBlob(
                    (blob) => {
                        if (blob) resolve(blob);
                        else reject(new Error("Canvas is empty"));
                    },
                    "image/webp",
                    0.8, // compression quality
                );
            };
            img.onerror = reject;
            img.src = event.target.result;
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
};

const truncateWords = (text = "", maxWords = 18) => {
    const words = text.trim().split(/\s+/);
    if (words.length <= maxWords) return text;
    return words.slice(0, maxWords).join(" ") + "…";
};

const getDeviceId = () => {
    let id = localStorage.getItem("deviceId");
    if (!id) {
        id = uuidv4();
        localStorage.setItem("deviceId", id);
    }
    return id;
};

const createSession = async (user) => {
    const sessionId = uuidv4();
    const deviceId = getDeviceId();

    localStorage.setItem("sessionId", sessionId);

    await set(ref(database, `Users/${user.uid}/sessions/${sessionId}`), {
        deviceId,
        platform: window.isIOS ? "ios" : window.isAndroid ? "android" : "web",
        createdAt: serverTimestamp(),
        lastSeen: serverTimestamp(),
    });
};

const saveToken = async (user) => {
    try {
        const deviceId = getDeviceId();
        const token = await requestNotificationPermission();
        if (token) {
            await set(ref(database, `Users/${user.uid}/fcmTokens/${deviceId}`), {
                token: token,
                updatedAt: serverTimestamp(),
                platform: window.isIOS ? "ios" : window.isAndroid ? "android" : "web",
            });

            // Topic subscription is handled by backend trigger when token is saved.
        }
    } catch (err) {
        console.error("Error saving FCM token:", err);
    }
};

const clearFcmToken = async (uid) => {
    const deviceId = getDeviceId();
    const sessionId = localStorage.getItem("sessionId");

    await Promise.all([
        remove(ref(database, `Users/${uid}/fcmTokens/${deviceId}`)),
        remove(ref(database, `Users/${uid}/sessions/${sessionId}`)),
    ]);
};

const isValidEmail = (value) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
};

const compressImage = async (file) => {
    const options = {
        maxSizeMB: 5,                // Practically no compression
        initialQuality: 1,           // No quality loss
        useWebWorker: true,
        fileType: file.type,         // Keep original format
    };

    return await imageCompression(file, options);
};

const convertHeicToJpg = async (file) => {
    const convertedBlob = await heic2any({
        blob: file,
        toType: "image/jpeg",
        quality: 0.8,
    });

    return new File([convertedBlob], file.name + ".jpg", {
        type: "image/jpeg",
    });
};

const formatRemainingTime = (expiresAt) => {
    const diffMs = expiresAt - Date.now();
    if (diffMs <= 0) return "expired";

    const minutes = Math.floor(diffMs / (1000 * 60));
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days > 0) return `${days} day${days > 1 ? "s" : ""}`;
    if (hours > 0) return `${hours} hour${hours > 1 ? "s" : ""}`;
    return `${minutes} minute${minutes > 1 ? "s" : ""}`;
};

const getDateKey = (ts) => {
    const d = new Date(ts);
    return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
};

const dayDiff = (d1, d2) => {
    const date1 = new Date(d1);
    const date2 = new Date(d2);

    date1.setHours(0, 0, 0, 0);
    date2.setHours(0, 0, 0, 0);

    return Math.round((date1 - date2) / (1000 * 60 * 60 * 24));
};

const calculateStreakWithFreeze = (
    lastActivity,
    streakCount = 0,
    freezeUsed = 0,
    freezeLimit = 2
) => {
    if (!lastActivity) {
        return { streakCount: 0, freezeUsed: 0 };
    }

    const diffDays = dayDiff(Date.now(), lastActivity);

    // same day
    if (diffDays === 0) {
        return { streakCount, freezeUsed };
    }

    // next day
    if (diffDays === 1) {
        return { streakCount: streakCount + 1, freezeUsed };
    }


    // missed days (freeze allowed)
    if (diffDays > 1 && diffDays <= freezeLimit + 2) {
        const needed = diffDays - 1;

        if (freezeUsed + needed > freezeLimit) {
            return { streakCount: 0, freezeUsed: 0 };
        }

        return {
            streakCount: streakCount + 1,
            freezeUsed: 0,
        };
    }

    // reset
    return { streakCount: 0, freezeUsed: 0 };
};

// Helper function to parse mentions from text
const parseMentions = (text, communityMembers, currentUser) => {
    const mentions = [];
    if (!text) return mentions;

    // ── NEW: structured format  @[Name](uid)  ──────────────────────────────
    const structuredRegex = /@\[([^\]]+)\]\(([^)]+)\)/g;
    let structuredMatch;
    while ((structuredMatch = structuredRegex.exec(text)) !== null) {
        const name = structuredMatch[1];
        const uid  = structuredMatch[2];
        if (uid !== currentUser?.uid) {
            mentions.push({ uid, name });
        }
    }

    // ── LEGACY: plain  @Name  format (backward-compat for old messages) ────
    // Only run if no structured tags were found (old messages won't have them)
    if (mentions.length === 0) {
        const mentionRegex = /@([^\n@\[]+)/g;
        let match;
        while ((match = mentionRegex.exec(text)) !== null) {
            const name = match[1].trim();
            if (!name) continue;

            // Exact full-name match first
            let member = communityMembers.find(
                m => m.name.toLowerCase() === name.toLowerCase()
            );

            // Username fallback (exact)
            if (!member) {
                member = communityMembers.find(
                    m => m.username && m.username.toLowerCase() === name.toLowerCase()
                );
            }

            if (member && member.uid !== currentUser?.uid) {
                mentions.push({ uid: member.uid, name: member.name });
            }
        }
    }

    // Deduplicate by uid
    const seen = new Set();
    return mentions.filter(m => {
        if (seen.has(m.uid)) return false;
        seen.add(m.uid);
        return true;
    });
};

// ✅ Format price for display
const formatPrice = (price, currency, productCurrency) => {
    if (!price || price === 0) return "Free";

    if (currency === "ZAR") {
        return `R${price.toFixed(2)}`;
    } else if (currency === "USD") {
        return `$${price.toFixed(2)}`;
    }

    // Fallback to product's original currency
    const productCurrencyFormatted = (productCurrency || "").trim().toUpperCase();
    if (productCurrencyFormatted === "ZAR") {
        return `R${price.toFixed(2)}`;
    } else {
        return `$${price.toFixed(2)}`;
    }
};

const copyToClipboard = async (text) => {
    // 🔥 FIRST: Try modern API safely
    try {
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text);
            return true;
        }
    } catch (err) {
        // iOS throws here — we silently continue to fallback
        console.warn("Modern clipboard failed, using fallback");
    }

    // 🔥 SECOND: iOS-safe fallback
    try {
        const textArea = document.createElement("textarea");
        textArea.value = text;

        // iOS requires element to be visible & selectable
        textArea.style.position = "absolute";
        textArea.style.left = "0";
        textArea.style.top = "0";
        textArea.style.opacity = "0";

        document.body.appendChild(textArea);

        textArea.focus();
        textArea.select();
        textArea.setSelectionRange(0, 999999); // VERY important for iOS

        const successful = document.execCommand("copy");

        document.body.removeChild(textArea);

        if (!successful) {
            throw new Error("Fallback copy failed");
        }

        return true;
    } catch (error) {
        console.error("Clipboard fallback failed:", error);
        throw error;
    }
};


const downgradeUser = async (userId) => {
    try {
        // Delete communities created by user
        const communitiesSnap = await get(ref(database, "Communities"));
        if (communitiesSnap.exists()) {
            const communitiesData = communitiesSnap.val();
            for (const [id, community] of Object.entries(communitiesData)) {
                if (community.hostId === userId) {
                    await remove(ref(database, `Communities/${id}`));
                }
            }
        }

        // Delete products/listings created by user
        const listingsSnap = await get(ref(database, "Listings"));
        if (listingsSnap.exists()) {
            const listingsData = listingsSnap.val();
            for (const [id, product] of Object.entries(listingsData)) {
                if (product.userId === userId) {
                    await remove(ref(database, `Listings/${id}`));
                }
            }
        }

        const userCommunitySnap = await get(ref(database, `Users/${userId}/hostedCommunities`));
        if (userCommunitySnap.exists()) {
            await remove(ref(database, `Users/${userId}/hostedCommunities`));
        }

        // Downgrade account
        await update(ref(database, `Users/${userId}`), {
            role: "Free",
            subscriptionStatus: "expired",
        });

        console.log(`✅ User ${userId} downgraded, communities and listings removed`);
    } catch (error) {
        console.error(`❌ Failed to downgrade user ${userId}:`, error);
    }
};

const handleDownloadImage = async (imageUrl) => {
    if (window.isInApp && window.ReactNativeWebView) {
        // React Native WebView: tell native app to download
        window.ReactNativeWebView.postMessage(
            JSON.stringify({
                type: "DOWNLOAD_IMAGE",
                imageUrl: imageUrl,
            })
        );
    } else {
        // Web: trigger download via anchor
        try {
            const response = await fetch(imageUrl);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            // Extract filename from URL or use a default
            const fileName = `image-${Date.now()}.jpg`;
            link.download = fileName;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Download failed:', error);
            alert('Failed to download image');
        }
    }
};

const getMonthKey = () => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

export {
    linkifyText,
    linkifyTextCommunity,
    formatTime,
    formatDate,
    getChatId,
    ratings,
    saveToken,
    EMOJIS,
    validateFile,
    convertToWebP,
    createSession,
    clearFcmToken,
    uploadFileToBunny,
    isBunnyVideoUrl,
    normalizeVideoOrientation,
    deriveOrientationFromDimensions,
    resolveBunnyVideoOrientation,
    getBunnyVideoFrameStyle,
    getBunnyEmbedUrl,
    deleteBunnyCollections,
    resizeImage,
    truncateWords,
    checkBunnyVideoStatus,
    getDeviceId,
    isValidEmail,
    checkVideoStatus,
    getVideoIdFromUrl,
    compressImage,
    formatRemainingTime,
    calculateStreakWithFreeze,
    parseMentions,
    formatPrice,
    copyToClipboard,
    downgradeUser,
    handleDownloadImage,
    getMonthKey,
    convertHeicToJpg
};

